import { useState, useEffect, FC } from "react";
import { AsyncAutocompleteField } from "@sainsburys-tech/luna-autocomplete";
import { loadFamilyGroupOptions } from "../../Service-Utils/helper";
import { FamilyGroupAutoCompleteProps } from "../../Types/familyGroupAutoCompleteProps";

const FamilyGroupAutoComplete: FC<FamilyGroupAutoCompleteProps> = (props) => {
  const [familyGroup, setFamilyGroup] = useState(props.initialValue || "");
  useEffect(() => {
    setFamilyGroup(props.initialValue);
  }, [props.initialValue]);

  return (
    <div data-testid="autocomplete-async-1">
      <AsyncAutocompleteField
        error={props.error}
        label={props.label}
        className={props.className}
        name={props.name}
        placeholder={props.placeholder}
        data-testid={props.testid}
        loadOptions={loadFamilyGroupOptions.bind(
          this,
          familyGroup,
          props.productType
        )}
        minChars={3}
        value={familyGroup}
        onSelect={(e: any) => {
          if (e === null) {
            setFamilyGroup("");
            if (
              props.initialValue === null ||
              props.initialValue === "" ||
              props.initialValue === undefined
            ) {
              return;
            }
          }
          props.onSelect(e);
        }}
        onChange={(e: any) => {
          setFamilyGroup(e.target.value);
          props.onSelect(e);
        }}
        disabled={props.disabled ? true : false}
      />
    </div>
  );
};

export default FamilyGroupAutoComplete;
